import React, { useState, useEffect, useRef } from "react";
import "flatpickr/dist/themes/material_green.css";
import { Link } from "react-router-dom";

import Flatpickr from "react-flatpickr";
import {
  Card,
  CardBody,
  Col,
  Row,
  Form,
  Container,
  Label,
  Input,
  Button,
} from "reactstrap";
import URLSearchParams from "@ungap/url-search-params";
// React Select
import Select from "react-select";
// MomentJS
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import _ from "lodash";
import { CircularProgress } from "@material-ui/core";


const PromoFormAdmin = (props) => {
  const [authToken, setAuthToken] = useState("");
  const [promo, setPromo] = useState(null);
  const [promoError, setPromoError] = useState(null);
  const [amount, setAmount] = useState(null);
  const [amountError, setAmountError] = useState(null);
  const [bundleCheck, setBundleChecked] = useState(false);
  const [noOfCodesCheck, setNoofCodesCheck] = useState(false);
  const [noOfCodesValue, setNoofCodesValue] = useState(1);
  const [noOfCodesValue1, setNoofCodesValue1] = useState(1);

  const [amount1, setAmount1] = useState();
  const [minvalue1, setMinvalue1] = useState();

  const [perday, setPerday] = useState("");
  const [maxPerDayCheck, setMaxPerDayCheck] = useState(false);
  const [maxPerDayCheck1, setMaxPerDayCheck1] = useState(false);
  const [maxPerCampaignCheck, setMaxPerCampaignCheck] = useState(false);
  const [maxPerCampaignCheck1, setMaxPerCampaignCheck1] = useState(false);
  const [min_spend, setMinSpend] = useState(null);
  const [min_spend1, setMinSpend1] = useState(null);
  const [min_spendError, setMinSpendError] = useState("");
  const [maxdiscount, setMaxdiscount] = useState(true);
  const [max_discountError, setMaxDiscountError] = useState("");
  const [min_quantity, setMinQuantity] = useState(null);
  const [min_quantityError, setMinQuantitytError] = useState("");
  const [termconditioin, setTermconditioin] = useState("");
  const [discountType, setDiscountType] = useState("amount");
  const [paymentMethod, setpaymentMethod] = useState("Visa");
  const [selectedMerchant, setSelectedMerchants] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [maxUsagePerDay, setMaxUsagePerDay] = useState(1);
  const [maxUsagePerCampaign, setMaxUsagePerCampaign] = useState(1);
  const [merchantOptions, setMerchantOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [noOfCodes, setnoOfCodes] = useState(null);
  const [noOfCodesError, setNoOfCodesError] = useState(null);
  const [success_msg, setsuccess_msg] = useState(false);
  const [errorMessage, SetErrorMessage] = useState("");
  const [errorMsgAlert, setErrorMsgAlert] = useState(false);
  const [allProductCheck, setAllProductCheck] = useState(false);
  const [addProductButton, setAddProductButton] = useState(false);
  const [manageQuantity, setManageQuantity] = useState(true);
  const [computedMinValue, setComputedMinValue] = useState("");
  const [computeMaxDiscount, setComputeMaxDiscount] = useState("");
  const [isMerchantLoggedIn, setIsMerchant] = useState(false);
  const [merchantCampaignDate, setMerchantCampaignDate] = useState("");
  const [checkCampaignName, setCheckCampaignName] = useState(false);
  const [termsAndCondition, setTermsAndCondition] = useState("");
  const [checkWholeNumber, setCheckWholeNumber] = useState(false);
  const [loader,setLoader]=useState(false)
  const [multiProduct, setmultiProduct] = useState([
    {
      label: "Select Product",
      value: "11",
      min_qty: "1",
    },
  ]);

  const fps = useRef(null);
  const fpe = useRef(null);

  useEffect(() => {
    console.log("hy i am promo form admin---->")
    let token = "";
    const isMerchant = localStorage?.getItem("isMerchant");
    if (isMerchant == "true") {
      setIsMerchant(true);
      token = localStorage.getItem("merchantToken");
      // document.getElementsByClassName("vertical-menu").style.display = "block"
    } else {
      setIsMerchant(false);
      token = localStorage.getItem("merchantToken");
    }
    if(localStorage.getItem("userRole")?.includes("merchant")){
      token=localStorage.getItem("AuthenticationToken")
    }
    setAuthToken(token);
    if (token !== "") {
      getMerchant(token);
      getCategories(token);
      getProducts(token);
      getCampaigns(token);
    }

    return () => {};
  }, []);
  const getCampaigns = async (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/campaigns?pageSize=-1`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let _data = JSON.parse(result);
        console.log("Campaign Data===>", _data);
        setMerchantCampaignDate(_data);
      });
  };
  const getCampaingnName = (e) => {
    console.log("merchant campaign date", merchantCampaignDate);
    const checkExistCampaignName =
      merchantCampaignDate.length > 0
        ? merchantCampaignDate?.some((item) => item.name === e)
        : "";
    // ? merchantCampaignDate.filter((item) => item.name === e && true)[0]
    // : "";

    console.log("checkCampaignName=======>>>>", checkExistCampaignName);
    setCheckCampaignName(checkExistCampaignName);
    if (checkExistCampaignName) {
      // setPromo(false);
      setPromoError(false);
    }
  };

  ///here is the ending
  const discountOptionGroup = [
    {
      options: [
        { label: "Fixed Amount Discount", value: "amount" },
        { label: "Percentage Discount", value: "percent" },
      ],
    },
  ];
  const maxUsageOptions = [
    {
      options: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
        { label: "13", value: "13" },
        { label: "14", value: "14" },
        { label: "15", value: "15" },
        { label: "16", value: "16" },
        { label: "17", value: "17" },
        { label: "18", value: "18" },
        { label: "19", value: "19" },
        { label: "20", value: "20" },
        { label: "21", value: "21" },
        { label: "22", value: "22" },
        { label: "23", value: "23" },
        { label: "24", value: "24" },
        { label: "25", value: "25" },
        { label: "26", value: "26" },
        { label: "27", value: "27" },
        { label: "28", value: "28" },
        { label: "29", value: "29" },
        { label: "30", value: "30" },
      ],
    },
  ];
  const paymentOptionGroup = [
    {
      options: [
        { label: "Visa", value: "Visa" },
        { label: "Master Card", value: "MasterCard" },
        { label: "Grab Pay", value: "GrabPay" },
      ],
    },
  ];

  let merchantOptionGroup = [];
  let categoryOptionGroup = [];
  let productOptionGroup = [];

  const getCurrentDate = () => {
    let date = moment(new Date()).format("YYYY-MM-DDTHH:MM");
    return date;
  };
  const getMerchant = async (token) => {
    let auth = "Bearer " + token;
    let _headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: auth,
    };
    var requestOptions = {
      method: "GET",
      headers: _headers,
      redirect: "follow",
    };
    await fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/merchants`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let _data = JSON.parse(result);
        let tempArr = _.sortBy(_data.data, "name");
        tempArr?.length > 0 &&
          tempArr.map((item, index) => {
            if (
              item.name !== "" &&
              item.external_id !== "" &&
              item.name.toLowerCase() !== "frx delivery"
            ) {
              merchantOptionGroup[index] = {
                label: `${item.name} (${item.email})`,
                value: item.external_id,
              };
            }
          });
        setMerchantOptions(merchantOptionGroup);
      })
      .catch((error) => console.log("error", error));
  };
  const getCategories = async (token) => {
    let auth = "Bearer " + token;
    let _headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: auth,
    };
    var requestOptions = {
      method: "GET",
      headers: _headers,
      redirect: "follow",
    };
    await fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/categories`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let _data = JSON.parse(result);
        let tempArr = _.sortBy(_data.data, "name");
        tempArr?.length > 0 &&
          tempArr.map((item, index) => {
            if (item.name !== "" && item.external_id !== "") {
              categoryOptionGroup[index] = {
                label: item.name,
                value: item.external_id,
              };
            }
          });
        setCategoryOptions(categoryOptionGroup);
      })
      .catch((error) => console.log("error", error));
  };
  let selecteditems = [];
  const getProducts = async (token = "", merchant = [], category = []) => {
    let auth = 0;
    if (token !== "") {
      auth = "Bearer " + token;
      console.log("Came in get products auth", token);
    } else {
      if (authToken !== "") auth = "Bearer " + authToken;
      console.log("Did not Came in get products auth", authToken);
    }
    let selectMerchants = JSON.stringify(merchant);
    let selectCategories = JSON.stringify(category);

    let _headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: auth,
    };
    var requestOptions = {
      method: "GET",
      headers: _headers,
      redirect: "follow",
    };

    let URl = "";
    if (merchant?.length > 0 && category?.length == 0) {
      URl = `${process.env.REACT_APP_TOKRI_API_URL}/api/products?pageSize=-1&merchant=${selectMerchants}`;
    } else if (category?.length > 0 && merchant?.length == 0) {
      URl = `${process.env.REACT_APP_TOKRI_API_URL}/api/products?pageSize=-1&category=${selectCategories}`;
    } else if (merchant?.length > 0 && category?.length > 0) {
      URl = `${process.env.REACT_APP_TOKRI_API_URL}/api/products?pageSize=-1&merchant=${selectMerchants}&category=${selectCategories}`;
    } else {
      URl = `${process.env.REACT_APP_TOKRI_API_URL}/api/products?pageSize=-1`;
    }

    await fetch(URl, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let _data = JSON.parse(result);
        let tempArr = _.sortBy(_data, "name");

        selecteditems = multiProduct;

        let results = tempArr?.filter(
          (item1) =>
            !selecteditems?.some((item2) => item2.value === item1.external_id)
        );
        // if (!allProductCheck) {
        tempArr.length > 0 &&
          results.map((item, index) => {
            if (
              item.name !== "" &&
              item.name.toLowerCase() !== "delivery" &&
              item.external_id !== ""
            ) {
              productOptionGroup[index] = {
                label: item.name,
                value: item.external_id,
              };
            }
          });
        setProductOptions(productOptionGroup);
        // }
        // else {
        //   // setProductOptions(tempArr)
        //   setSelectedProduct(tempArr)
        //   console.log("check-box Clicked data", productOptions)
        // }
      })
      .catch((error) => console.log("error", error));
  };
  const getallProducts = async (token = "", merchant = [], category = []) => {
    selecteditems = [];
    let auth = 0;
    if (token !== "") {
      auth = "Bearer " + token;
    } else {
      if (authToken !== "") auth = "Bearer " + authToken;
    }
    let selectMerchants = JSON.stringify(merchant);
    let selectCategories = JSON.stringify(category);

    let _headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: auth,
    };
    var requestOptions = {
      method: "GET",
      headers: _headers,
      redirect: "follow",
    };

    let URl = "";
    if (merchant?.length > 0 && category?.length == 0) {
      URl = `${process.env.REACT_APP_TOKRI_API_URL}/api/products?pageSize=-1&merchant=${selectMerchants}`;
    } else if (category?.length > 0 && merchant?.length == 0) {
      URl = `${process.env.REACT_APP_TOKRI_API_URL}/api/products?pageSize=-1&category=${selectCategories}`;
    } else if (merchant?.length > 0 && category?.length > 0) {
      URl = `${process.env.REACT_APP_TOKRI_API_URL}/api/products?pageSize=-1&merchant=${selectMerchants}&category=${selectCategories}`;
    } else {
      URl = `${process.env.REACT_APP_TOKRI_API_URL}/api/products?pageSize=-1`;
    }

    await fetch(URl, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let _data = JSON.parse(result);
        let tempArr = _.sortBy(_data, "name");
        if (!allProductCheck) {
          tempArr.length > 0 &&
            tempArr.map((item, index) => {
              if (
                item.name !== "" &&
                item.name.toLowerCase() !== "delivery" &&
                item.external_id !== ""
              ) {
                productOptionGroup[index] = {
                  label: item.name,
                  value: item.external_id,
                };
              }
            });
          setSelectedProduct(productOptionGroup);
        } else {
          setSelectedProduct("");
        }
      })
      .catch((error) => console.log("error", error));
  };

  function handleDiscountType(event) {
    setDiscountType(event.value);
    var str = event.value;
    if (str == "amount") {
      setMaxdiscount(true);
    } else {
      setMaxdiscount(false);
    }
  }
  function handlePaymentInput(event) {
    setpaymentMethod(event.value);
  }
  function handlePromoInput(e) {
    if (e.target.value.length < 25 && e.target.value.length > 6) {
      setPromoError(false);
      setPromo(true);
    } else if (e.target.value.length === 24) {
      setPromo(true);
      setPromoError(false);
    } else if (e.target.value.length === 0) {
      setPromo(false);
      setPromoError(false);
    } else if (e.target.value.length > 24 || e.target.value.length < 6) {
      setPromo(false);
      setPromoError(true);
    }
  }
  function handleNoCodesInput(e) {
    if (!noOfCodesCheck) {
      var regex1 = /[A-Z]|[a-z]/g;
      var regex = /[-+]?([0-9]*\.[0-9]+|[0-9]+)/g;
      var str = e.target.value.toString();
      var stv = parseInt(str);
      setNoofCodesValue1(parseInt(e.target.value));
      if (stv < maxUsagePerCampaign && stv < maxUsagePerDay) {
        setMaxPerCampaignCheck1(false);
        setMaxPerDayCheck1(false);
      } else if (stv >= maxUsagePerCampaign && stv < maxUsagePerDay) {
        setMaxPerCampaignCheck1(true);
        setMaxPerDayCheck1(false);
      } else if (stv < maxUsagePerCampaign && stv >= maxUsagePerDay) {
        setMaxPerCampaignCheck1(false);
        setMaxPerDayCheck1(true);
      } else if (stv >= maxUsagePerCampaign && stv >= maxUsagePerDay) {
        setMaxPerCampaignCheck1(true);
        setMaxPerDayCheck1(true);
      }

      setNoofCodesValue(e.target.value);
      if (e.target.value == "") {
        setnoOfCodes(false);
        setNoOfCodesError(false);
      } else if (regex.test(str) && !regex1.test(str)) {
        setnoOfCodes(true);
        setNoOfCodesError(false);
      } else if (!regex.test(str)) {
        setnoOfCodes(null);
        setNoOfCodesError(true);
      }
    }
  }
  function handleAmountInput(e) {
    var regex1 = /[A-Z]|[a-z]|[.]+/g;
    var regex = /[-+]?([0-9]*\.[0-9]+|[0-9]+)/g;
    setAmount1(parseFloat(e.target.value));
    var str = e.target.value.toString();

    if (str > minvalue1) {
      setMinSpend1(false);
    } else if (str <= minvalue1) {
      setMinSpend1(true);
    }

    if (discountType == "amount") {
      if (e.target.value == "") {
        setAmount(false);
        setAmountError(false);
        setCheckWholeNumber(false);
      } else if (regex.test(str) && !regex1.test(str)) {
        setAmount(true);
        setAmountError(false);
        setCheckWholeNumber(false);
      } else if (!regex.test(str)) {
        setAmount(null);
        setAmountError(true);
      }
    } else if (discountType == "percent") {
      if (e.target.value == "") {
        setAmount(false);
        setAmountError(false);
      }
      // else if (!e.target.value == '') {
      //   setAmount(true)
      //   setAmountError(false)
      // }
      else if (regex.test(str) && !regex1.test(str)) {
        let percentage = parseFloat(str);
        if (percentage < 100) {
          setAmount(true);
          setAmountError(false);
        } else {
          setAmount(null);
          setAmountError(true);
        }
      } else if (!regex.test(str)) {
        setAmount(null);
        setAmountError(true);
      }
    }
  }

  function handleMaxDiscountInput(e) {
    var regex1 = /[A-Z]|[a-z]|[.]+/g;
    var regex = /[-+]?([0-9]*\.[0-9]+|[0-9]+)/g;
    var str = e.target.value.toString();
    var ste = (minvalue1 / 100) * amount1;
    setComputeMaxDiscount(str);

    if (e.target.value == "") {
      setMaxdiscount(false);
      setMaxDiscountError(false);
    } else if (regex.test(str) && !regex1.test(str)) {
      if (str < ste) {
        setMaxdiscount(false);
      } else {
        setMaxdiscount(true);
        setMaxDiscountError(false);
      }
    } else if (!regex.test(str)) {
      setMaxdiscount(null);
      setMaxDiscountError(true);
    } else if (!e.target.value == "") {
      setMaxdiscount(true);
      setMaxDiscountError(false);
    }
  }

  function handleMinSpendInput(e) {
    var regex1 = /[A-Z]|[a-z]|[.]+/g;
    var regex = /[-+]?([0-9]*\.[0-9]+|[0-9]+)/g;
    setMinvalue1(parseFloat(e.target.value));
    var str = e.target.value.toString();
    if (str >= 1 && discountType == "percent") {
      setMinSpend1(true);
    } else if (str < amount1) {
      setMinSpend1(false);
    } else if (str >= amount1) {
      setMinSpend1(true);
    }
    if (e.target.value == "") {
      setMinSpend(false);
      setMinSpendError(false);
    } else if (regex.test(str) && !regex1.test(str)) {
      setMinSpend(true);
      setMinSpendError(false);
    } else if (!regex.test(str)) {
      setMinSpend(null);
      setMinSpendError(true);
    }
  }
  // here start of campaign

  function handleSubmit(e) {
    if (!e) {
      return false;
    }
    e.preventDefault();
    console.log("working asjdjas");
    var promo = document.getElementById("promocode-input").value;
    var amount = document.getElementById("amount-input").value;
    var st_date = moment(fps.current.flatpickr.selectedDates[0]).format(
      "YYYY-MM-DDTHH:mm"
    );
    var end_date = moment(fpe.current.flatpickr.selectedDates[0]).format(
      "YYYY-MM-DDTHH:mm"
    );
    // var st_date = document.getElementById("start_date_input").value;
    // var end_date = document.getElementById("end_date_input").value;
    var min_spend = document.getElementById("minspend-input").value;
    var min_quantity = document.getElementById("minquantity-input").value;
    var quantityofCodes = noOfCodesValue;
    var tnc = document.getElementById("terms-and-conditions-input").value;
    console.log(
      "promo=====================>,===============>",
      promo,
      amount,
      min_spend1,
      manageQuantity,
      maxdiscount,
      termsAndCondition,
      selectedProduct
    );
    console.log("promo", promo);
    console.log("Amount", amount);
    console.log("st_date", st_date);
    console.log("min_spend", min_spend);
    console.log("min_quantity", min_quantity);
    console.log("quantityofCodes", quantityofCodes);

    if (promo === "") {
      setPromo(false);
    } else {
      setPromo(true);
    }

    if (amount === "") {
      setAmount(false);
    } else {
      // var letters = "/\w|\W/g";
      setAmount(true);
    }
    if (quantityofCodes === "") {
      setnoOfCodes(false);
    } else {
      // var letters = "/\w|\W/g";
      setnoOfCodes(true);
    }

    // if (st_date === "") {
    //   setStartDate(false)
    // } else {
    //   setStartDate(st_date)
    // }

    // if (st_time === "") {
    //   setStartTime(false)
    // } else {
    //   setStartTime(st_time)
    // }

    // if (end_date === "") {
    //   setEndDate(false)
    // } else {
    //   setEndDate(end_date)
    // }

    // if (end_time === "") {
    //   setEndTime(false)
    // } else {
    //   setEndTime(end_time)
    // }

    if (min_spend === "") {
      setMinSpend(false);
    } else {
      setMinSpend(min_spend);
    }

    if (maxdiscount === "") {
      setMaxdiscount(false);
    } else {
      setMaxdiscount(maxdiscount);
    }
    var d1 = document.getElementsByName("validate");

    document.getElementById("tooltipForm").classList.add("was-validated");

    for (var i = 0; i < d1.length; i++) {
      d1[i].style.display = "block";
    }
    // post form data to api
    if (promo !== "" && amount !== "" && min_spend !== "") {
       setLoader(true)
      createCampaign(
        promo,
        discountType,
        bundleCheck,
        amount,
        paymentMethod,
        st_date,
        end_date,
        quantityofCodes,
        noOfCodesCheck,
        maxUsagePerDay,
        maxPerDayCheck,
        maxUsagePerCampaign,
        maxPerCampaignCheck,
        min_spend,
        selectedMerchant,
        selectedCategory,
        selectedProduct,
        min_quantity ? min_quantity : 1,
        tnc
      );
    }
  }

  const createCampaign = (
    promo,
    type,
    bundle,
    amount,
    payment,
    st_date,
    end_date,
    noOfCodes,
    promoLimitCheck,
    maxPerDay,
    maxPerDayCheck,
    maxPerCampaign,
    maxPerCampaignCheck,
    min_spend,
    merchant,
    category,
    product,
    min_quantity,
    tnc
  ) => {
    console.log("working in create fun");
    let token = authToken;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);

    var urlencoded = new URLSearchParams();
    // urlencoded.append("marketplace_id", "6a125896-1fe8-4fb0-9e13-8f45f1131d44"); // uncomment this for localhost
    urlencoded.append(
      "marketplace_id",
      window.location.hostname == "tokri.spoonspace.com"
        ? "6a125896-1fe8-4fb0-9e13-8f45f1131d44"
        : "53fc4dac-490c-4dca-a255-dfc9c4310890"
    ); // comment this for localhost
    urlencoded.append("name", promo);
    urlencoded.append("discount_type", type ? type : "amount");
    if (bundle) {
      urlencoded.append("bundle", 1);
    } else {
      urlencoded.append("bundle", 0);
    }
    urlencoded.append("discount_amount", amount);
    urlencoded.append("payment_method", payment);
    urlencoded.append("start_date", st_date);
    urlencoded.append("end_date", end_date);
    if (promoLimitCheck) {
      urlencoded.append("max_promocodes_allocated", -1);
    } else {
      urlencoded.append("max_promocodes_allocated", noOfCodes);
    }
    // if (maxPerDayCheck) {
    //   urlencoded.append("max_limit_per_day", -1);
    // } else {
    //   urlencoded.append("max_limit_per_day", maxPerDay);
    // }
    // if (maxPerCampaignCheck) {
    //   urlencoded.append("max_limit_per_user", -1);
    // } else {
    //   urlencoded.append("max_limit_per_user", maxPerCampaign);
    // }
    urlencoded.append("min_spend", min_spend);
    if (discountType == "percent") {
      var max_discount = document.getElementById("max-discount-input").value;
      urlencoded.append("max_discount", max_discount);
    }
    urlencoded.append("discount_merchants", JSON.stringify(merchant));
    urlencoded.append("discount_categories", JSON.stringify(category));
    urlencoded.append("discount_products", JSON.stringify(product));
    console.log(
      "products being added",
      product,
      document?.getElementById("minquantity-input")?.value
    );
    urlencoded.append("min_quantity", min_quantity);
    urlencoded.append("discount_store_wide", allProductCheck ? 1 : 0);
    if (tnc !== "") {
      urlencoded.append("tnc", tnc);
    }
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };
    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/campaigns`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log("Result here :  ", result.errors);
        if (
          result?.errors &&
          result?.errors.length > 0 &&
          result?.errors[0]?.includes("The name has already been taken.")
        ) {
          SetErrorMessage(result.errors);
          setErrorMsgAlert(true);
          setCheckCampaignName(true);
          setPromo(false);
        } else if (
          result?.message &&
          result?.message.toLowerCase() === "campaign record created"
        ) {
          setsuccess_msg(true);
          setLoader(false)
        } else {
          SetErrorMessage(result.message || result.error);
          setErrorMsgAlert(true);
          setLoader(false)
        }
      })
      .catch((error) => console.log("Campaign Creation error", error));
  };
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props.props?.history.push("/merchant-dashboard");
        }}
        onConfirm={() => {
          setsuccess_msg(false);
          setLoader(false)
          props.props?.history.push("/merchant-dashboard");
        }}
        onCancel={() => {
          setsuccess_msg(false);
        }}
      >
        {"Campaign Created Successfully."}
      </SweetAlert>
    );
  };
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false);
          setLoader(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };
  const handeBundleCheck = () => {
    setBundleChecked(!bundleCheck);
  };
  const handleNoofCodesCheck = (evt) => {
    setNoofCodesCheck(!noOfCodesCheck);
  };
  const handleMaxPerDayCheck = () => {
    setMaxPerDayCheck(!maxPerDayCheck);
  };
  const handleMaxPerCampaignCheck = () => {
    setMaxPerCampaignCheck(!maxPerCampaignCheck);
  };
  const handleAllProductCheck = () => {
    setAllProductCheck(!allProductCheck);
    setSelectedProduct([]);
    getallProducts();
    setManageQuantity(true);
    setmultiProduct([
      {
        label: "Select Product",
        value: "",
        min_qty: "",
      },
    ]);
  };
  // let multiProduct = [
  //   {
  //     label: 'hello',
  //     value: ''
  //   }
  // ]
  {
    console.log("here is selected product", selectedProduct);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            {isMerchantLoggedIn && <Col lg={1}></Col>}
            <Col lg={10} md={10} sm={10}>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={10} md={10} sm={10}>
                      <div className="mt-5 mt-lg-4">
                        <Form
                          className=""
                          method="post"
                          id="tooltipForm"
                          onSubmit={(e) => {
                            e.preventDefault();
                            console.log("calling function ");
                            if (
                              // !checkCampaignName &&
                              promo &&
                              amount &&
                              min_spend1 &&
                              manageQuantity &&
                              maxdiscount &&
                              termsAndCondition &&
                              selectedProduct.length > 0
                            ) {
                              handleSubmit(e);
                            }
                          }}
                        >
                          <div>
                            <Row>
                              <Col lg={6} md={6} sm={6}>
                                <div className="mb-4 position-relative">
                                  <Label
                                    className="col-sm-8 col-form-label"
                                    htmlFor="formrow-firstname-input"
                                  >
                                    Campaign Name
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="promocode-input"
                                    onChange={(e) => {
                                      handlePromoInput(e);
                                      getCampaingnName(e.target.value);
                                    }}
                                    required
                                  />
                                  {checkCampaignName && (
                                    <div style={{ color: "red", fontSize: 12 }}>
                                      Name already taken
                                    </div>
                                  )}
                                  {!checkCampaignName &&
                                  !promoError &&
                                  promo ? (
                                    <div
                                      style={{ color: "green", fontSize: 12 }}
                                    >
                                      Looks Good!
                                    </div>
                                  ) : promoError ? (
                                    <div style={{ color: "red", fontSize: 12 }}>
                                      Campaign name cannot be longer than 24
                                      alphanumeric characters and less then 6
                                      alphanumeric characters .
                                    </div>
                                  ) : (
                                    promo == false &&
                                    checkCampaignName == false && (
                                      <div
                                        style={{ color: "red", fontSize: 12 }}
                                      >
                                        Please enter Campaign Name.
                                      </div>
                                    )
                                  )}
                                </div>
                              </Col>
                            </Row>

                            <Row lg={12} md={12} sm={12}>
                              <Col lg={4} md={6} sm={6}>
                                <div className="mb-3">
                                  <Label>Discount Type</Label>
                                  <Select
                                    isSearchable={false}
                                    value={discountType}
                                    // isDisabled={bundleCheck}
                                    onChange={(e) => {
                                      handleDiscountType(e);
                                    }}
                                    placeholder={
                                      discountType == ""
                                        ? "Select Discount Type"
                                        : discountType == "amount"
                                        ? "Fixed Amount"
                                        : "Percentage Amount"
                                    }
                                    defaultValue={
                                      discountOptionGroup.length > 0 &&
                                      discountOptionGroup[0].label
                                    }
                                    options={discountOptionGroup}
                                    required
                                  />
                                </div>
                              </Col>
                              <Col lg={2} md={6} sm={6}>
                                <div
                                  className="form-check mb-12"
                                  style={{ marginTop: 40, marginLeft: 10 }}
                                >
                                  <input
                                    className="form-check-input-lg"
                                    type="checkbox"
                                    defaultChecked={bundleCheck}
                                    id="bundle-check"
                                    onChange={() => {
                                      handeBundleCheck();
                                    }}
                                  />
                                  <label
                                    className="form-check-label-lg"
                                    htmlFor="invalidCheck"
                                    style={{ marginLeft: 5, fontSize: 14 }}
                                  >
                                    Bundle?
                                  </label>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={6} md={6} sm={6}>
                                <div className="mb-3 position-relative">
                                  <Label
                                    className="form-label"
                                    htmlFor="formrow-firstname-input"
                                  >
                                    Amount(
                                    {discountType == "amount" ? "$" : "%"})
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="amount-input"
                                    onInvalid={(e) => {
                                      e.target.setCustomValidity(
                                        "Please Enter A whole Number"
                                      );
                                    }}
                                    pattern="[0-9]+"
                                    onChange={(e) => {
                                      e.target.setCustomValidity("");
                                      handleAmountInput(e);
                                    }}
                                    // onInvalid={this.setCustomValidity(
                                    //   "Please enter whole number"
                                    // )}
                                    required
                                  />

                                  {amount == true && (
                                    <div
                                      style={{ fontSize: 12, color: "green" }}
                                    >
                                      Looks good!
                                    </div>
                                  )}
                                  {amount == false &&
                                    discountType == "amount" && (
                                      <div
                                        style={{ fontSize: 12, color: "red" }}
                                      >
                                        Please enter dollar amount.
                                      </div>
                                    )}
                                  {amount == false &&
                                    discountType !== "amount" && (
                                      <div
                                        style={{ fontSize: 12, color: "red" }}
                                      >
                                        Please enter percentage amount.
                                      </div>
                                    )}
                                  {amountError == true &&
                                    discountType == "amount" && (
                                      <div
                                        style={{
                                          color: "red",
                                          fontSize: 12,
                                          fontWeight: "400",
                                        }}
                                      >
                                        Please enter a whole number.
                                      </div>
                                    )}
                                  {amountError == true &&
                                    discountType !== "amount" && (
                                      <div
                                        style={{
                                          color: "red",
                                          fontSize: 12,
                                          fontWeight: "400",
                                        }}
                                      >
                                        Please enter a whole number lessthan 101
                                      </div>
                                    )}
                                </div>
                              </Col>
                              <Col lg={1}></Col>
                              {/* <Col lg={5} md={6} sm={6}>
                                <div className="mb-3">
                                  <Label>Payment Method</Label>
                                  <Select
                                    isSearchable={true}
                                    value={paymentMethod}
                                    onChange={(e) => {
                                      handlePaymentInput(e)
                                    }}
                                    placeholder={paymentMethod ? paymentMethod : "Select Payment Method"}
                                    defaultValue={paymentOptionGroup.length > 0 && paymentOptionGroup[0].label}
                                    options={paymentOptionGroup}
                                    required
                                  />
                                </div>
                              </Col> */}
                            </Row>
                            <Row>
                              <Col lg={6} md={6} sm={6}>
                                <div className="mb-3 position-relative">
                                  <Label
                                    className="form-label"
                                    htmlFor="formrow-firstname-input"
                                  >
                                    Start Date
                                  </Label>
                                  <div className="col-md-12">
                                    <Flatpickr
                                      style={{ background: "white" }}
                                      data-enable-time
                                      className="form-control"
                                      type="datetime-local"
                                      defaultValue={getCurrentDate()}
                                      id="start_date_input"
                                      options={{
                                        dateFormat: "d/m/Y h:i K",
                                        defaultDate: new Date(),
                                      }}
                                      ref={fps}
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col lg={1}></Col>
                              <Col lg={5} md={6} sm={6}>
                                <div className="mb-3 position-relative">
                                  <Label>End Date</Label>
                                  <div className="col-md-12">
                                    <Flatpickr
                                      style={{ background: "white" }}
                                      data-enable-time
                                      className="form-control"
                                      type="datetime-local"
                                      defaultValue={getCurrentDate()}
                                      id="end_date_input"
                                      options={{
                                        dateFormat: "d/m/Y h:i K",
                                        defaultDate: new Date(),
                                      }}
                                      ref={fpe}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            {/* <Row lg={12} md={12} sm={12}> */}
                            {/* <Col lg={4} md={6} sm={6}>
                                <div className="mb-3 position-relative">
                                  <Label>No. of Promo Codes</Label>
                                  <Input type="number" className="form-control" id="no-of-codes-input"
                                    disabled={noOfCodesCheck}
                                    value={noOfCodesCheck ? "" : noOfCodesValue}

                                    onChange={e => {
                                      handleNoCodesInput(e)
                                      return
                                    }}
                                    required />
                                  {!noOfCodesCheck && noOfCodes == true &&
                                    <div style={{ fontSize: 12, color: "green" }}>
                                      Looks good!
                                    </div>}
                                  {!noOfCodesCheck && noOfCodes == false &&
                                    <div style={{ color: "red", fontSize: 12, fontWeight: "300" }}>
                                      Please enter number of promo codes.

                                    </div>}
                                  {!noOfCodesCheck && noOfCodesError == true &&
                                    <div style={{ color: "red", fontSize: 12, fontWeight: "300" }}>
                                      Number of promo codes is not valid.
                                    </div>}
                                </div>
                              </Col>
                              <Col lg={2} md={6} sm={4}>
                                <div className="form-check mb-8" style={{ marginTop: 40, marginLeft: 10 }}>


                                  <input className="form-check-input-lg"
                                    type="checkbox" defaultChecked={noOfCodesCheck}
                                    id="no-of-promocode-check"
                                    onChange={() => {
                                      handleNoofCodesCheck()

                                    }}
                                    required />
                                  <label className="form-check-label-lg" htmlFor="invalidCheck" style={{ marginLeft: 5, fontSize: 14 }}>
                                    No Limit?
                                  </label>
                                </div>
                              </Col>
                            </Row> */}
                            {/* <Row lg={12} md={12} sm={12}>
                              <Col lg={4} md={6} sm={6}>
                                <div className="mb-3 position-relative">
                                  <Label>Max per user/per day</Label>

                                  <Select
                                    value={maxPerDayCheck ? "" : (maxUsagePerDay ? maxUsagePerDay : 0)}
                                    placeholder={maxPerDayCheck ? "" : (maxUsagePerDay ? maxUsagePerDay : "Select max usage per day")}
                                    onChange={(e) => {
                                      setMaxUsagePerDay(parseInt(e.value))
                                      if (noOfCodesValue1 < maxUsagePerDay) {
                                        setMaxPerDayCheck1(false)
                                      }
                                      else if (noOfCodesValue1 > maxUsagePerDay) {
                                        setMaxPerDayCheck1(true)
                                      }
                                    }}
                                    options={maxUsageOptions}
                                    isDisabled={maxPerDayCheck}
                                    required
                                  />
                                  {noOfCodesValue1 < maxUsagePerDay &&
                                    <div style={{ fontSize: 12, color: "red" }}>
                                      Maximum per user/per day cannot be higher than no. of promo codes.

                                    </div>}
                                </div>
                              </Col>
                              <Col lg={2} md={4} sm={4}>
                                <div className="form-check mb-3" style={{ marginTop: 40, marginLeft: 10 }}>
                                  <input className="form-check-input-lg" type="checkbox" defaultChecked={maxPerDayCheck} id="max-user-per-day-check"

                                    onChange={() => { handleMaxPerDayCheck() }}

                                    required />
                                  <label className="form-check-label-lg" htmlFor="invalidCheck" style={{ marginLeft: 5, fontSize: 14 }}>
                                    No Limit?
                                  </label>
                                </div>
                              </Col>
                              <Col lg={1}></Col>
                              <Col lg={3} md={6} sm={6}>
                                <div className="mb-6">
                                  <Label>Max per user/per Campaign</Label>
                                  <Select
                                    value={maxPerCampaignCheck ? "" : (maxUsagePerCampaign ? maxUsagePerCampaign : 0)}
                                    placeholder={maxPerCampaignCheck ? "" : (maxUsagePerCampaign ? maxUsagePerCampaign : "Select max usage per campaign")}
                                    onChange={(e) => {
                                      setMaxUsagePerCampaign(parseInt(e.value))
                                      if (noOfCodesValue1 < maxUsagePerCampaign) {
                                        setMaxPerCampaignCheck1(false)
                                      }
                                      else if (noOfCodesValue1 > maxUsagePerCampaign) {
                                        setMaxPerCampaignCheck1(true)
                                      }
                                    }}
                                    isDisabled={maxPerCampaignCheck}
                                    options={maxUsageOptions}
                                  />


                                  {noOfCodesValue1 < maxUsagePerCampaign &&
                                    <div style={{ fontSize: 12, color: "red" }}>
                                      Maximum per user/per day cannot be higher than no. of promo codes.

                                    </div>}
                                </div>
                              </Col>
                              <Col lg={2} md={4} sm={4}>
                                <div className="form-check mb-3" style={{ marginTop: 40, marginLeft: 10 }}>
                                  <input className="form-check-input-lg" type="checkbox" defaultChecked={maxPerCampaignCheck} id="max-user-per-campaign-check"
                                    onChange={() => { handleMaxPerCampaignCheck() }}
                                    required />
                                  <label className="form-check-label-lg" htmlFor="invalidCheck" style={{ marginLeft: 5, fontSize: 14 }}>
                                    No Limit?
                                  </label>
                                </div>
                              </Col>
                            </Row> */}
                            <Row>
                              <Col lg={6} md={6} sm={6}>
                                <div className="mb-3 position-relative">
                                  <Label
                                    className="form-label"
                                    htmlFor="formrow-firstname-input"
                                  >
                                    Minimum Spend($)
                                  </Label>
                                  <Input
                                    // step={0.01}
                                    type="text"
                                    className="form-control"
                                    id="minspend-input"
                                    onInvalid={(e) => {
                                      e.target.setCustomValidity(
                                        "Please Enter A whole Number"
                                      );
                                    }}
                                    pattern="[0-9]+"
                                    onChange={(e) => {
                                      e.target.setCustomValidity("");
                                      handleMinSpendInput(e);
                                    }}
                                    min={0}
                                    required
                                  />
                                  {minvalue1 < amount1 &&
                                    discountType == "amount" && (
                                      <div
                                        style={{ fontSize: 12, color: "red" }}
                                      >
                                        Minimum spend should be higher than
                                        dollar amount discount.
                                      </div>
                                    )}
                                  {minvalue1 < amount1 &&
                                    discountType == "percent" && (
                                      <div
                                        style={{ fontSize: 12, color: "green" }}
                                      >
                                        Looks good!
                                      </div>
                                    )}
                                  {min_spend == true && minvalue1 > amount1 && (
                                    <div
                                      style={{ fontSize: 12, color: "green" }}
                                    >
                                      Looks good!
                                    </div>
                                  )}
                                  {min_spend == false && (
                                    <div style={{ fontSize: 12, color: "red" }}>
                                      Please enter minimum spend amount.
                                    </div>
                                  )}
                                  {min_spendError == true && (
                                    <div
                                      style={{
                                        color: "red",
                                        fontSize: 12,
                                        fontWeight: "400",
                                      }}
                                    >
                                      Please Enter a whole Number
                                    </div>
                                  )}
                                </div>
                              </Col>
                              <Col lg={1}></Col>
                              <Col lg={5} md={6} sm={6}>
                                {discountType == "percent" && (
                                  <div className="mb-3 position-relative">
                                    <Label
                                      className="form-label"
                                      htmlFor="formrow-firstname-input"
                                    >
                                      Maximum Discount($)
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="max-discount-input"
                                      onInvalid={(e) => {
                                        e.target.setCustomValidity(
                                          "Please Enter A whole Number"
                                        );
                                      }}
                                      pattern="[0-9]+"
                                      onChange={(e) => {
                                        e.target.setCustomValidity("");
                                        handleMaxDiscountInput(e);
                                        let computeMinValue =
                                          (minvalue1 / 100) * amount1;
                                        setComputedMinValue(computeMinValue);
                                      }}
                                      // min={computedMinValue}
                                      required
                                    />
                                    {computeMaxDiscount < computedMinValue && (
                                      <div
                                        style={{ fontSize: 12, color: "red" }}
                                      >
                                        maximum discount should be greater than
                                        ${computedMinValue}
                                      </div>
                                    )}
                                    {maxdiscount == true &&
                                      computeMaxDiscount > computedMinValue && (
                                        <div
                                          style={{
                                            fontSize: 12,
                                            color: "green",
                                          }}
                                        >
                                          Looks good!
                                        </div>
                                      )}
                                    {/* {maxdiscount == false && 
                                      <div style={{ fontSize: 12, color: "red" }}>
                                        Please enter maximum amount discount.
                                      </div>} */}
                                    {max_discountError == true && (
                                      <div
                                        style={{
                                          color: "red",
                                          fontSize: 12,
                                          fontWeight: "400",
                                        }}
                                      >
                                        Please enter a whole number
                                      </div>
                                    )}
                                  </div>
                                )}
                              </Col>
                            </Row>
                            <Row>
                              {/* <Col lg={6} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Merchant</Label>
                              <Row>
                              <Col>
                              <Select
                                isSearchable={true}
                                onChange={(e) => {
                                  setSelectedMerchants(e)
                                  if(authToken !== '')
                                  getProducts(authToken, e)                               
                                }}
                                placeholder={"Select Merchant"}
                                defaultValue={merchantOptionGroup.length > 0 && merchantOptionGroup[0].label}
                                options={merchantOptions}                                
                                isMulti
                              />
                              </Col>
                              </Row>
                            </div>
                            </Col> */}
                            </Row>
                            {/* <Row>
                            <Col lg={6} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Category</Label>
                              <Select
                                isSearchable={true}
                                onChange={(e) => {
                                  setSelectedCategory(e)
                                  if(authToken !== ''){
                                    if(selectedMerchant){
                                      getProducts(authToken, selectedMerchant, e)
                                    }else{
                                      getProducts(authToken, [], e)
                                    }
                                    
                                  }
                                }}
                                placeholder={"Select Category"}
                                defaultValue={categoryOptionGroup.length > 0 && categoryOptionGroup[0].label}
                                options={categoryOptions}
                                isMulti
                              />
                            </div>
                            </Col>
                          </Row> */}
                            <Row>
                              <Col lg={6} md={6} sm={6}>
                                <div className="mb-4 position-relative">
                                  <Label
                                    className="col-sm-8 col-form-label"
                                    htmlFor="formrow-firstname-input"
                                  >
                                    {"Terms & Conditions"}
                                  </Label>
                                  <Input
                                    type="textarea"
                                    className="form-control"
                                    id="terms-and-conditions-input"
                                    onChange={(e) => {
                                      setTermsAndCondition(e.target.value);
                                      if (e.target.value == "") {
                                        setTermconditioin(false);
                                      } else if (
                                        isNaN(parseInt(e.target.value))
                                      ) {
                                        setTermconditioin(null);
                                      } else if (
                                        !isNaN(parseInt(e.target.value))
                                      ) {
                                        setTermconditioin(true);
                                      }
                                    }}
                                    required
                                  />
                                  {termconditioin == false && (
                                    <div className="invalid-feedback">
                                      Please add terms & conditions.
                                    </div>
                                  )}
                                </div>
                              </Col>
                            </Row>
                            {multiProduct &&
                              multiProduct?.map((item, index) => (
                                <Row>
                                  {console.log("here is the item 1", item)}
                                  <Col lg={4} md={6} sm={6}>
                                    <div className="mb-3">
                                      {index === 0 && <Label>Product</Label>}
                                      <Select
                                        isSearchable={true}
                                        onChange={(e) => {
                                          let updatedArray = multiProduct;

                                          updatedArray[index] = e;
                                          updatedArray[index].min_qty = "1";
                                          setmultiProduct(updatedArray);
                                          setSelectedProduct(updatedArray);
                                          console.log(
                                            "multiProduct===>",
                                            multiProduct
                                          );
                                          console.log(
                                            "selectedProduct===>",
                                            selectedProduct
                                          );
                                          getProducts();
                                        }}
                                        placeholder={
                                          allProductCheck
                                            ? ""
                                            : "Select Product"
                                        }
                                        defaultValue={
                                          productOptionGroup.length > 0 &&
                                          productOptionGroup[0].label
                                        }
                                        options={productOptions}
                                        // isMulti
                                        isDisabled={
                                          allProductCheck ||
                                          (item.label !== "Select Product" &&
                                            index !== 0)
                                        }
                                        id="product-select-box"
                                        value={allProductCheck ? "" : item}
                                      />
                                    </div>
                                  </Col>
                                  <Col
                                    lg={1}
                                    md={4}
                                    sm={4}
                                    style={{
                                      marginTop: "auto",
                                      marginBottom: "auto",
                                      position: "relative",
                                    }}
                                  >
                                    {index === 0 ? (
                                      <button
                                        onClick={() => {
                                          document.getElementById(
                                            "minquantity-input"
                                          ).value = 1;
                                          let newArayy = multiProduct;
                                          newArayy = [
                                            {
                                              label: "Select Product",
                                              value: "",
                                              min_qty: "",
                                            },
                                            ...newArayy,
                                          ];
                                          setmultiProduct(newArayy);
                                        }}
                                        disabled={
                                          allProductCheck ||
                                          item.label == "Select Product" ||
                                          item.min_qty == ""
                                        }
                                        style={{
                                          fontSize: "30px",
                                          fontWeight: "700",
                                        }}
                                        className="plus-btn btn btn-default"
                                      >
                                        +
                                      </button>
                                    ) : (
                                      <button
                                        onClick={() => {
                                          let updatedArray = multiProduct;
                                          updatedArray?.splice(index, 1);
                                          const _updatedArray =
                                            updatedArray?.filter(
                                              (item) =>
                                                item.label !== "Select Product"
                                            );
                                          setmultiProduct(updatedArray);
                                          setSelectedProduct(_updatedArray);
                                          getProducts();
                                        }}
                                        style={{
                                          fontSize: "30px",
                                          fontWeight: "700",
                                          position: "absolute",
                                          bottom: "-15px",
                                        }}
                                        className="plus-btn btn btn-default"
                                      >
                                        ×
                                      </button>
                                    )}
                                  </Col>

                                  <Col lg={4} md={6} sm={6}>
                                    <div className="mb-3 position-relative">
                                      {index === 0 && (
                                        <Label>Minimum Quantity</Label>
                                      )}
                                      {index === 0 ? (
                                        <Input
                                          type="number"
                                          className="form-control"
                                          id="minquantity-input"
                                          // value={1}
                                          defaultValue={
                                            allProductCheck ? "" : 1
                                          }
                                          // placeholder={1}
                                          // {index === 0 ? defaultValue= {1}: value(item?.min_qty)}

                                          // value={allProductCheck ? '0' : item.min_qty}

                                          disabled={
                                            allProductCheck ||
                                            item.label == "Select Product" ||
                                            index !== 0
                                          }
                                          onChange={(e) => {
                                            let updatedArray = multiProduct;
                                            updatedArray[index].min_qty =
                                              e.target.value;
                                            setmultiProduct(updatedArray);
                                            setSelectedProduct(updatedArray);
                                            setManageQuantity(e.target.value);
                                            getProducts();
                                          }}
                                          min={1}
                                          required
                                        />
                                      ) : (
                                        <Input
                                          type="number"
                                          className="form-control"
                                          id="minquantity-input"
                                          value={
                                            allProductCheck ? "" : item.min_qty
                                          }
                                          disabled={
                                            allProductCheck ||
                                            item.label == "Select Product" ||
                                            index !== 0
                                          }
                                          onChange={(e) => {
                                            let updatedArray = multiProduct;
                                            updatedArray[index].min_qty =
                                              e.target.value;
                                            setmultiProduct(updatedArray);
                                            setSelectedProduct(updatedArray);
                                            setManageQuantity(e.target.value);
                                            getProducts();
                                          }}
                                          min={1}
                                          required
                                        />
                                      )}
                                      {min_quantity == true && (
                                        <div
                                          style={{
                                            color: "green",
                                            fontSize: 12,
                                          }}
                                        >
                                          Looks Good.
                                        </div>
                                      )}
                                      {index === 0 && !manageQuantity && (
                                        <div
                                          style={{ color: "red", fontSize: 12 }}
                                        >
                                          Please enter minimum quantity.
                                        </div>
                                      )}
                                      {min_quantity == false && (
                                        <div
                                          style={{ color: "red", fontSize: 12 }}
                                        >
                                          Please enter minimum quantity.
                                        </div>
                                      )}
                                      {min_quantityError == true && (
                                        <div
                                          style={{ color: "red", fontSize: 12 }}
                                        >
                                          Minimum quantity is not valid.
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                  {index === 0 && (
                                    <Col lg={3} md={4} sm={4}>
                                      <div
                                        className="form-check mb-3"
                                        style={{
                                          marginTop: 40,
                                          marginLeft: 10,
                                        }}
                                      >
                                        <input
                                          className="form-check-input-lg"
                                          type="checkbox"
                                          defaultChecked={allProductCheck}
                                          id="max-user-per-campaign-check"
                                          onChange={(e) => {
                                            handleAllProductCheck();
                                          }}
                                          // required
                                        />
                                        <label
                                          className="form-check-label-lg"
                                          // htmlFor="invalidCheck"
                                          style={{
                                            marginLeft: 5,
                                            fontSize: 14,
                                          }}
                                        >
                                          Select Entire Store
                                        </label>
                                      </div>
                                    </Col>
                                  )}
                                </Row>
                              ))}

                            {success_msg ? renderSuccessAlert() : null}
                            {errorMsgAlert ? renderFailureAlert() : null}

                            {console.log("promo", promo)}
                            {console.log("amount", amount)}
                            {console.log("min_spend1", min_spend1)}
                            {console.log("maxdiscount", maxdiscount)}
                            {console.log("manageQuantity", manageQuantity)}

                            <div
                              style={{
                                display: "inline-flex",
                              }}
                              className="text-center mt-4"
                            >
                              <Button
                                // type="submit"
                                style={{width:"160px"}}
                                color="primary"
                                className="btn btn-primary waves-effect waves-light"
                                disabled={loader}
                                // onClick={(e) => {
                                //   if (
                                //     // !checkCampaignName &&
                                //     promo &&
                                //     amount &&
                                //     min_spend1 &&
                                //     manageQuantity &&
                                //     maxdiscount &&
                                //     termsAndCondition &&
                                //     selectedProduct.length > 0
                                //   ) {
                                //     handleSubmit(e);
                                //   }
                                // }}
                              >
                                {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Create Campaign"}
                              </Button>
                              <div style={{ marginLeft: "10px" }}>
                                <Link to="/merchant-dashboard">
                                  <Button outline color="secondary" size="md">
                                    Cancel
                                  </Button>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PromoFormAdmin;
